<app-floorplan-item-details [floorplanItem]="protectiveTube()">
  <div data-main>
    @if (protectiveTubeForm) {
      <form odxForm [formGroup]="protectiveTubeForm" [disabled]="protectiveTube().locked">
        <odx-form-field i18n-label="@@floorplan.details.protectiveTube.form.name.label" label="Name">
          <input
            formControlName="name"
            odxFormFieldControl
            i18n-placeholder="@@floorplan.details.protectiveTube.form.name.placeholder"
            placeholder="Name"
          />
        </odx-form-field>
        <odx-form-field i18n-label="@@floorplan.details.protectiveTube.form.material.label" label="Material">
          <input
            formControlName="material"
            odxFormFieldControl
            i18n-placeholder="@@floorplan.details.protectiveTube.form.material.placeholder"
            placeholder="Material"
          />
        </odx-form-field>
      </form>
    }
    <app-reference-measurement-item-length [floorplanItem]="protectiveTube()"></app-reference-measurement-item-length>
  </div>
</app-floorplan-item-details>
